/**
 * UTM Parameters Data Layer Integration
 * Extracts UTM parameters from URL and adds them to dataLayer
 * Also stores in sessionStorage for persistence across page navigation
 */

(function() {
  'use strict';

  // Initialize dataLayer if it doesn't exist
  window.dataLayer = window.dataLayer || [];

  /**
   * Extract UTM parameters from URL
   * @returns {Object} Object containing UTM parameters
   */
  function extractUTMParameters() {
    const urlParams = new URLSearchParams(window.location.search);
    const utmParams = {};
    
    // Standard UTM parameters
    const utmKeys = [
      'utm_source',
      'utm_medium', 
      'utm_campaign',
      'utm_term',
      'utm_content',
      'utm_id',
      'utm_source_platform',
      'utm_creative_format',
      'utm_marketing_tactic'
    ];

    utmKeys.forEach(key => {
      const value = urlParams.get(key);
      if (value) {
        utmParams[key] = value;
      }
    });

    return utmParams;
  }

  /**
   * Get UTM parameters from sessionStorage or current URL
   * @returns {Object} UTM parameters object
   */
  function getUTMParameters() {
    // First check if we have UTM parameters in the current URL
    const currentUTMs = extractUTMParameters();
    
    // If we have current UTM parameters, use them and store in sessionStorage
    if (Object.keys(currentUTMs).length > 0) {
      try {
        sessionStorage.setItem('utm_parameters', JSON.stringify(currentUTMs));
        return currentUTMs;
      } catch (e) {
        console.warn('Could not store UTM parameters in sessionStorage:', e);
        return currentUTMs;
      }
    }
    
    // If no current UTM parameters, try to get from sessionStorage
    try {
      const storedUTMs = sessionStorage.getItem('utm_parameters');
      if (storedUTMs) {
        return JSON.parse(storedUTMs);
      }
    } catch (e) {
      console.warn('Could not retrieve UTM parameters from sessionStorage:', e);
    }
    
    return {};
  }

  /**
   * Add UTM parameters to dataLayer
   */
  function addUTMToDataLayer() {
    const utmParams = getUTMParameters();
    
    if (Object.keys(utmParams).length > 0) {
      // Create a dataLayer event with UTM parameters
      const utmEvent = {
        event: 'utm_parameters_loaded',
        utm_parameters: utmParams,
        timestamp: new Date().toISOString(),
        page_url: window.location.href,
        page_title: document.title
      };

      // Push to dataLayer
      window.dataLayer.push(utmEvent);
      
      // Also push individual UTM parameters for easier access
      const individualUTMEvent = {
        event: 'utm_individual_parameters',
        ...utmParams,
        timestamp: new Date().toISOString()
      };
      
      window.dataLayer.push(individualUTMEvent);
      
      console.log('UTM parameters added to dataLayer:', utmParams);
    } else {
      console.log('No UTM parameters found');
    }
  }

  /**
   * Initialize UTM tracking
   */
  function initUTMTracking() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', addUTMToDataLayer);
    } else {
      // DOM is already ready
      addUTMToDataLayer();
    }
  }

  // Initialize when script loads
  initUTMTracking();

  // Also expose function globally for manual triggering if needed
  window.addUTMToDataLayer = addUTMToDataLayer;

})();
